// Module
var code = "<div id=\"multi_download_container\" style=\"top: -1100px !important; left: 100px;  z-index:22320 !important; height: 200px;border: 2px solid red; position: absolute\"> </div>";
// Exports
export default code;